/**
 * 模組頁面代碼: 1350-UI
 * 模組說明: 控制信號管理功能頁面框架
 * @module ControlCodeContainer
 */

// ----- import from local libraries -----
import {
    React,
    PropTypes,
    connect,
    BaseComponent,
} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
//import Sidebar from '../../features/main-frame/components/Sidebar';
import ControlCodePage from './components/ControlCodePage';
import ControlCodeModal from './components/ControlCodeModal';
import {AlertModal, AlertModalModeEnums } from '../../components/AlertModal';
import { MessageModal, MessageModalModeEnums } from '../../components/MessageModal';

// ----- import from local actions -----
import {
    addControlCode,
    editControlCode,
    deleteControlCode,
    fetchControlCode,
    fetchControlCodeList,
} from '../../redux/actions/ControlCodeActions';

// ----- constants and enums -----
const ControlCodeModalModeEnums = {
    NEW: 'new',
    EDIT: 'edit',
};

const ACTION_TARGET_CONTROL_CODE = 'controlCode';

class ControlCodeContainer extends BaseComponent {
    constructor(props) {
        super(props);
        // 創建 ref
        this.controlCodeModalRef = React.createRef();
        this.alertModalRef = React.createRef();
        this.messageModalRef = React.createRef();
        this.controlCodeModal = null;
        this.alertModal = null;
        this.messageModal = null;

        this.state = {
            needControlCodeLoad: false,
            controlCodeModalMode: ControlCodeModalModeEnums.NEW,
            actionMode: AlertModalModeEnums.DELETE,
            actionTarget: '',
            controlCode: null,
            alertMessage: '',
            actionIds: [],
            message: { mode: MessageModalModeEnums.ERROR, title: '', body: ''},
            search: { controlCode: '', controlType: '' },
        };
        this.toggleControlCodeModal = this.toggleControlCodeModal.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    toggleControlCodeModal(isShow, mode = ControlCodeModalModeEnums.NEW, index = null) {
        if (this.controlCodeModal) {
            if (mode === ControlCodeModalModeEnums.EDIT) {
                this.setState({ controlCode: this.props.controlCodeList[index] });
            } else {
                this.setState({ controlCode: null });
            }

            if (isShow) {
                this.controlCodeModal.show();
            } else {
                this.controlCodeModal.hide();
            }
            this.setState({ controlCodeModalMode: mode });
        }
    }

    toggleAlertModal(isShow, mode = AlertModalModeEnums.ENABLE, target, message = '', actionIds = []) {
        if (this.alertModal) {
            if (isShow) {
                let alertMessage = message;
                if (alertMessage === '') {
                    let length = actionIds.length;
                    if (mode === AlertModalModeEnums.ENABLE) {
                        alertMessage = `啟用 [ ${length} ] 筆資料`;
                    } else if (mode === AlertModalModeEnums.DISABLE) {
                        alertMessage = `停用 [ ${length} ] 筆資料`;
                    } else if (mode === AlertModalModeEnums.DELETE) {
                        alertMessage = `刪除 [ ${length} ] 筆資料`;
                    }
                }
                this.setState({ actionMode: mode });
                this.setState({ alertMessage: alertMessage });
                this.setState({ actionTarget: target});
                this.setState({ actionIds: actionIds });
                this.alertModal.show();
            } else {
                this.alertModal.hide();
            }
        }
    }

    toggleMessageModal(isShow, mode = MessageModalModeEnums.INFO, title = '', message = '') {
        if (this.messageModal) {
            if (isShow) {
                let body = message;
                const statusCode = message?.code || '';
                if (statusCode !== '') {
                    body = `[ ${statusCode} ] ${message.message}`;
                }
                this.setState({ message: { mode: mode, title: title, body: body }});
                this.messageModal.show();
            } else {
                this.messageModal.hide();
            }
        }
    }

    onConfirm() {
        const actionTarget = this.state.actionTarget;
        const actionMode = this.state.actionMode;
        const actionIds = this.state.actionIds;

        if (actionTarget === ACTION_TARGET_CONTROL_CODE) {
            if (actionMode === AlertModalModeEnums.DELETE) {
                const controlIdStr = actionIds.join(',');
                this.props.deleteControlCode(controlIdStr).then(() => {
                    const { controlCode, controlType } = this.state.search;
                    this.props.fetchControlCodeList(controlCode, controlType).then(() => {
                        this.setState({ needControlCodeLoad: true });
                        this.toggleAlertModal(false);
                    });
                });
            }
        }
    }

    componentDidMount() {
        // 頁面所需資料初始化
        this.props.fetchControlCodeList('', '').then(() => {
            this.setState({ needControlCodeLoad: true });
        });
        this.controlCodeModal = new bootstrap.Modal(this.controlCodeModalRef.current);
        this.alertModal = new bootstrap.Modal(this.alertModalRef.current);
        this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
    }
    
    componentDidUpdate(prevProps, prevState) {
    }

    componentWillUnmount() {
        this.toggleControlCodeModal(false);
        this.toggleAlertModal(false);
        this.toggleMessageModal(false);
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <div className="header__Placeholder"></div>
                <div className="m__wrap">
                    <div className="m__contents">
                        {/* <Sidebar /> */}
                        <ControlCodePage
                            {...this.props}
                            needControlCodeLoad={this.state.needControlCodeLoad}
                            setNeedControlCodeLoad={(bLoad) => this.setState({ needControlCodeLoad: bLoad })}
                            onNewControlCode={() => this.toggleControlCodeModal(true, ControlCodeModalModeEnums.NEW)}
                            onEditControlCode={(index) => this.toggleControlCodeModal(true, ControlCodeModalModeEnums.EDIT, index)}
                            onDeleteControlCode={(message, controlId) => this.toggleAlertModal(true, AlertModalModeEnums.DELETE, ACTION_TARGET_CONTROL_CODE, message, [controlId])}
                            onBatchHandle={(mode, controlIds) => this.toggleAlertModal(true, mode, ACTION_TARGET_CONTROL_CODE, '', controlIds)}
                            setSearchControlCode={(controlCode, controlType) => { 
                                this.setState({ search: { controlCode: controlCode, controlType: controlType } });
                            }}
                        />
                    </div>
                </div>
                <Footer />
                <ControlCodeModal 
                    {...this.props}
                    ref={this.controlCodeModalRef}
                    mode={this.state.controlCodeModalMode}
                    controlCode={this.state.controlCode}
                    searchControlCode={this.state.search}
                    setNeedControlCodeLoad={(bLoad) => this.setState({ needControlCodeLoad: bLoad })}
                    onErrorHandle={(title, message) => this.toggleMessageModal(true, MessageModalModeEnums.ERROR, title, message)}
                />
                <AlertModal
                    ref={this.alertModalRef}
                    mode={this.state.actionMode}
                    message={this.state.alertMessage}
                    onConfirm={() => this.onConfirm()}
                    onCancel={() => this.setState({ needControlCodeLoad: true })}
                />
                <MessageModal
                    ref={this.messageModalRef}
                    mode={this.state.message.mode}
                    title={this.state.message.title}
                    message={this.state.message.body}
                />
            </React.Fragment>
        );
    }
}

ControlCodeContainer.propTypes = {
    userPermissions: PropTypes.array,
    controlCodeList: PropTypes.array,
};

ControlCodeContainer.defaultProps = {
    userPermissions: [],
    controlCodeList: []
};

function mapStateToProps(state) {
    return {
        userPermissions: state.access.userPermissions,
        controlCodeList: state.controlCode.controlCodeList.data,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addControlCode: (controlCode) => {
            return dispatch(addControlCode(controlCode));
        },
        editControlCode: (controlCode) => {
            return dispatch(editControlCode(controlCode));
        },
        deleteControlCode: (controlIds) => {
            return dispatch(deleteControlCode(controlIds));
        },
        fetchControlCode: (controlId) => {
            return dispatch(fetchControlCode(controlId));
        },
        fetchControlCodeList: (controlCode, controlType) => {
            return dispatch(fetchControlCodeList({ controlCode, controlType }));
        },
    };    
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlCodeContainer);